import { useState } from 'react';
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

function PortfolioSection() {
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [photoIndex, setPhotoIndex] = useState(0);
    const portfolio = [
        {
            image: "/images/glancceil.jpg",
            title: "Глянцевый потолок",
            description: "Современная гостиная"
        },
        {
            image: "/images/matceil.jpg",
            title: "Матовый потолок",
            description: "Спальня в классическом стиле"
        },
        {
            image: "/images/svetline.jpg",
            title: "Световые линии",
            description: "Спальня в классическом стиле"
        },
        {
            image: "/images/satin.jpg",
            title: "Сатин потолок",
            description: "Спальня в классическом стиле"
        },
        {
            image: "/images/dvux.jpg",
            title: "Двухуровневый потолок",
            description: "Гостиная с зонированием"
        },
        {
            image: "/images/parsvet.jpg",
            title: "Парящий потолок",
            description: "Современный минимализм"
        },
        {
            image: "/images/tkan.jpg",
            title: "Тканевый потолок",
            description: "Экологичный дизайн"
        },
        {
            image: "/images/photo.jpg",
            title: "Фотопечать",
            description: "Индивидуальный дизайн"
        },
        {
            image: "/images/ceilkaf.jpg",
            title: "Натяжные потолки по кафелю",
            description: "Индивидуальный дизайн"
        },
        {
            image: "/images/insttracksys.jpg",
            title: "Установка трековых систем",
            description: "Индивидуальный дизайн"
        },
        {
            image: "/images/shadowceil.jpg",
            title: "Теневые потолки",
            description: "Индивидуальный дизайн"
        },
        {
            image: "/images/instlusbra.jpg",
            title: "Установка люстр и бра",
            description: "Индивидуальный дизайн"
        }
    ];

    const slides = portfolio.map(item => ({ src: item.image, alt: item.title }));

    const openLightbox = (index) => {
        setPhotoIndex(index);
        setLightboxOpen(true);
    };

    return (
        <section id="portfolio" className="portfolio-section">
            <div className="container">
                <div className="text-center mb-5">
                    <h2 className="section-title text-white">Наши работы</h2>
                    <p className="section-subtitle">Примеры выполненных проектов</p>
                </div>
                <Swiper
                    modules={[Navigation, Pagination]}
                    spaceBetween={30}
                    slidesPerView={1}
                    navigation
                    pagination={{ clickable: true }}
                    breakpoints={{
                        640: { slidesPerView: 2 },
                        992: { slidesPerView: 3 },
                        1200: { slidesPerView: 4 }
                    }}
                    className="my-portfolio-swiper"
                >
                    {portfolio.map((item, index) => (
                        <SwiperSlide key={index}>
                            <div className="portfolio-item" onClick={() => openLightbox(index)}>
                                <img src={item.image} alt={item.title} />
                                <div className="portfolio-overlay">
                                    <h4>{item.title}</h4>
                                    <p>{item.description}</p>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
                <Lightbox
                    open={lightboxOpen}
                    close={() => setLightboxOpen(false)}
                    slides={slides}
                    index={photoIndex}
                    plugins={[Zoom]}
                />
            </div>
        </section>
    );
}

export default PortfolioSection;